import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Button from "../../Button";
import DeadlineCountdownBox from "../../DeadlineCountdownBox";
import Fixtures from "../../Fixtures";
import MostSelectedPlayers from "../MostSelectedPlayers";
import PlayerAvailabilityTable from "../PlayerAvailabilityTable";
import {
  ButtonWrapper,
  CountdownTimerSection,
  StatsTableItem,
  StatsTableSection,
  StatusPreRolloverWrapper,
} from "./styles";
import type { StatusPreRolloverProps } from "./types";

const StatusPreRollover = ({ nextEvent }: StatusPreRolloverProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StatusPreRolloverWrapper>
      <CountdownTimerSection>
        <div>
          <DeadlineCountdownBox />
        </div>
        <ButtonWrapper>
          <Button
            variant="primary"
            width={1}
            onClick={() => navigate("/my-team")}
          >
            {t("status.manageMyTeam", "Manage my team")}
          </Button>
          <Button
            variant="primary"
            width={1}
            onClick={() => navigate("/transfers")}
          >
            {t("createSquad.makeTransfers", "Make Transfers")}
          </Button>
        </ButtonWrapper>
      </CountdownTimerSection>
      <StatsTableSection>
        <StatsTableItem $mobileOrder={1}>
          <MostSelectedPlayers />
        </StatsTableItem>
        <StatsTableItem $mobileOrder={3}>
          <PlayerAvailabilityTable playerCount={20} />
        </StatsTableItem>
        <StatsTableItem $mobileOrder={2}>
          <Fixtures eventId={nextEvent.id} hidePager />
        </StatsTableItem>
      </StatsTableSection>
    </StatusPreRolloverWrapper>
  );
};

export default StatusPreRollover;
